<template>
  <div class="select-wings">
    <md-select
        ref="SelectWings"
        :value="value"
        :md-class="mdClass"
        :data-value="getValueForTesting"
        :placeholder="placeholder"
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('input',$event)"
        @md-opened="onMdOpened"
        @md-closed="onMdClosed"
        name="select-wings">
      <div class="md-layout-item" v-if="searchField">
        <md-field class="mt10" :class="mdClass">
          <label>{{ $t("search") }}</label>
          <md-input type="text" v-model="search" @input="debounceInput"></md-input>
        </md-field>
      </div>
      <slot :options="availableOptions">
        <md-option v-for="(option, index) in availableOptions" :value="option" :key="index">
          {{ option }}
        </md-option>
      </slot>
    </md-select>
    <md-button v-if="!$attrs.disableDelete && !$attrs.disabled && (value || typeof value === 'number') && (!Array.isArray(value) || value.length > 0)"
               v-bind="$attrs"
               :id="`button_reset_${$attrs.id}`"
               @click="onReset"
               class="md-icon-button md-dense md-input-action md-clear md-theme-default">
      <md-icon>close</md-icon>
    </md-button>
    <md-tooltip v-show="mdTooltip !== undefined" :md-direction="mdTooltipDirection">{{ mdTooltip }}</md-tooltip>
  </div>
</template>

<script>
import {debounce, throttle} from "lodash"

export default {
  name: "Wings-Select",
  props:{
    options:{type:Array},
    value:{type:Array|String|Number},
    searchField:{type:String},
    valueField:{type:String},
    mdClass:{type:String},
    mdTooltip:{type:String},
    mdTooltipDirection:{type:String, default:'right'},
    placeholder:{type:Array|String|Number},
    autocomplete:{type:Boolean, default:false},
    queryField:{type:String},
  },
  data() {
    return {
      search: '',
      isMounted: false,
      listNode: undefined,
      filter: {
        page_number: 1,
        query: '',
        queryField: undefined
      }
    }
  },
  computed:{
    availableOptions(){
      if (!this.search) return this.options;
      if (!this.searchField){
        return this.options.filter(option => option.toLowerCase().includes(this.search.toLowerCase()));
      }
      let searchOptions = this.options.filter(option => option[this.searchField].toLowerCase().includes(this.search.toLowerCase()));
      if (this.valueField){
        let newOption = {};
        newOption[this.searchField] = this.search;
        newOption[this.valueField] = this.search;
        searchOptions.push(newOption)
      }

      return searchOptions;
    },
    getValueForTesting() {
      if (!this.isMounted) {
        return null;
      }
      if (this.$refs.SelectWings) {
        return this.$refs.SelectWings.MdSelect.label
      }
      if (this.placeholder && !this.value) return this.placeholder
      return this.value
    }
  },
  mounted() {
    this.isMounted = true;
    if (this.queryField) this.filter.queryField = this.queryField
  },
  methods: {
    debounceInput: debounce(function (value) {
      this.filter.query = value
      this.filter.page_number = 1
      this.$emit('searchInput', this.filter)
    }, 500),
    onMdOpened() {
      if (this.autocomplete) {
        this.filter.query = ''
        this.filter.page_number = 1
        this.$emit('searchInput', this.filter)
        this.listNode = document.querySelector('.md-menu-content-container.md-scrollbar');
        this.listNode.addEventListener('scroll', this.scrollFunction)
      }
    },
    onMdClosed() {
      this.search = ''
      if (this.autocomplete) this.$emit('update:options', [])
    },
    onReset() {
      this.$emit('input',undefined)
      if (this.autocomplete) this.$emit('update:options', [])
    },
    scrollFunction: throttle(function () {
      const scrollBottom = this.listNode.scrollTop + this.listNode.clientHeight;
      const scrollThreshold = this.listNode.scrollHeight - 1;

      if (scrollBottom >= scrollThreshold) {
        this.filter.page_number++;
        this.$emit('searchInput', this.filter);
      }
    }, 200)
  },
  beforeDestroy() {
    if (this.listNode) {
      this.listNode.removeEventListener('scroll', this.scrollFunction)
    }
  }
}
</script>

<style>
.select-wings {
  flex: 1;
  position:relative;
  max-width: 100%;
}
.select-wings__clear {
  position: absolute;
  right: 20px;
  bottom: 5px;
}
</style>
